import ComprehensiveIcon from '../assets/images/components/ComprehensiveIcon';
import LegalCaseIcon from '../assets/images/components/LegalCaseIcon';
import RegulatoryUpdateIcon from '../assets/images/components/RegulatoryUpdateIcon';
import TrainingProgIcon from '../assets/images/components/TrainingProgIcon';
import CorporateImg from '../assets/images/CorporateImage.png';
import { CorporateSectionData } from './interface/interface';

export const corporateSectionData: CorporateSectionData = {
  info: {
    image: CorporateImg,
    para1:
      'Empowering businesses with expert legal guidance across corporate law, compliance, and risk management. Navigate complex regulations seamlessly while fostering growth and innovation. From startups to large enterprises, ensure your business operates securely and future-ready.',
    para2:
      'Corporate law is the foundation of every business, shaping how companies are structured, managed, and governed. From incorporation and contracts to compliance, mergers, and dispute resolution, it ensures your business runs smoothly within legal boundaries while protecting your interests and stakeholders.',
  },
  desc: [
    {
      title: 'Expert Legal Support',
      description:
        'Avoid costly risks and make informed decisions with guidance from seasoned legal professionals.',
    },
    {
      title: 'Strategic Growth Guidance',
      description: 'Navigate complex transactions, funding, and acquisitions with confidence.',
    },
    {
      title: 'Future-Ready Protection',
      description: 'Safeguard your business while staying compliant and competitive.',
    },
  ],
  cards: [
    {
      icon: <LegalCaseIcon />,
      heading: 'Legal Consultation and Strategic Advisory',
      content: 'Expert guidance and strategic planning to navigate evolving legal requirements.',
    },
    {
      icon: <RegulatoryUpdateIcon />,
      heading: 'Regulatory Updations',
      content:
        'Timely updates on relevant statutes, rules, notifications, and circulars impacting your business.',
    },
    {
      icon: <TrainingProgIcon />,
      heading: 'Training and Awareness Programs',
      content: 'Custom programs to educate teams on key legal and compliance topics.',
    },
    {
      icon: <ComprehensiveIcon />,
      heading: 'Comprehensive Compliance Management',
      content: 'Proactive management of legal and regulatory compliance to mitigate risk.',
    },
  ],
};
